import { privateAgent } from "@lib/Requests/AuthRequests";
import { routesName } from "@lib/RoutesName";
import { AddChangePwProps } from "@lib/Types";
import Cookies from "js-cookie";
import { enqueueSnackbar, useSnackbar } from "notistack";
import { useMutation } from "react-query";

interface ChangePasswordResponse {
  status: number;
  result?: string;
  error?: string;
  message: string;
}

const changePasswordRequest = async (values: AddChangePwProps): Promise<ChangePasswordResponse> => {
  try {
    const userId = Cookies.get("userId");
    if (!userId) {
      throw new Error("User ID not found in cookies");
    }

    const resp = await privateAgent.post<ChangePasswordResponse>(
      routesName.AuthRoute({}).changePassword,
      { ...values, userId: userId }
    );

    if (resp.status !== 201) {
      console.error("Error changing password:", resp.data.error);
      throw new Error(resp.data.error || "Failed to change password");
    }

    return resp.data;
  } catch (error: any) {
    console.error("Error changing password:", error.message);
    throw new Error(error.response?.data?.error || error.message || "An error occurred");
  }
};

export const useChangePassword = () => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationKey: ['changePassword'],
    mutationFn: changePasswordRequest,
    onSuccess: (data) => {
      enqueueSnackbar(data.result ?? "Password changed successfully", { variant: "success" });
    },
    onError: (error: any) => {
      console.error("Error changing password:", error.message);
      enqueueSnackbar(error.message ?? "An error occurred", { variant: "error" });
    },
  });
};